<template>

</template>

<script>
    import Chart from 'chart.js';

    export default {
        name: "FlowLineChart",
        props: ["canvasId", "data", "xlabels", "chartHeading"],
        data() {
            return {
                flowBlue: '#094e77',
                flowGreen: '#2ea878',
                pink: 'lightblue',
                fontProperties: {
                    fontColor: '#094e77',
                    fontFamily: 'Caladea',
                    fontSize: 16,
                    boxWidth: 10,
                    usePointStyle: true
                }
            }
        },
        mounted() {
            var ctx = document.getElementById(this.canvasId).getContext('2d');
            new Chart(ctx, {
                type: 'line',
                data: {
                    labels: this.xlabels,
                    datasets: [
                        {
                            label: this.chartHeading,
                            fontStyle: 'bold',
                            backgroundColor: 'rgba(9,78,118,0.3)',
                            borderColor: this.flowBlue,
                            data: this.data,
                            fill: true,
                            pointRadius: 10,
                            pointStyle: 'rectRot',
                            pointHoverRadius: 10,
                            pointBackgroundColor: this.flowGreen,
                            // lineTension: 0.9
                        }
                    ]
                },

                options: {
                    layout: {
                        padding: {
                            bottom: 50
                        }
                    },
                    maintainAspectRatio: true,
                    legend: {
                        display: true,
                        labels: this.fontProperties,
                    },
                    scales: {
                        xAxes: [
                            {
                                ticks: this.fontProperties,
                                gridLines: {
                                    display: true
                                }
                            },
                        ],
                        yAxes: [{
                            ticks: {
                                suggestedMin: 0,
                                suggestedMax: 25,
                                stepSize: 5,
                                fontColor: '#094e77',
                                fontFamily: 'Caladea',
                                fontSize: 16,
                            },
                            gridLines: {
                                display: true
                            }
                        }]
                    }
                }
            });
        }
    }
</script>

<style scoped>

</style>